import {
  BackgroundTypeGradient,
  BackgroundTypeColor,
  BackgroundTypeImage,
  BackgroundTypeImageAndColor,
  ImageAsBackground,
  ImageGradient,
  BackgroundVideo,
} from './_partials';
const {
  i18n: { __ },
  components: { PanelBody, SelectControl, ToggleControl },
} = wp;

const BackgroundTypes = ({
  setAttributes,
  backgroundType,
  backgroundGradientOptions,
  backgroundColorOptions,
  backgroundImageOptions,
  backgroundImageAndColorOptions,
  imageAsBackgroundOptions,
  imageGradientBackgroundOptions,
  backgroundVideoOptions,
  printBackgroundStyles = false,
}) => {
  return (
    <>
      <PanelBody title={__('Background Type', 'b3rg')} initialOpen={true}>
        <SelectControl
          value={backgroundType}
          options={[
            { value: '', label: 'Select Background' },
            {
              value: 'background_image',
              label: 'Background Image',
            },
            {
              value: 'background_color',
              label: 'Background Color',
            },
            {
              value: 'background_image_color',
              label: 'Background Image & Color',
            },
            {
              value: 'image_gradient',
              label: 'Background Image & Gradient',
            },
            // {value: "background_video", label: "Background Video"},
            {
              value: 'background_gradient',
              label: 'Background Gradient',
            },
            { value: 'picture_tag', label: 'Image as a Background' },
            { value: 'background_video', label: 'Background Video' },
          ]}
          onChange={(newValue) => {
            setAttributes({ backgroundType: newValue });
          }}
        />

        {backgroundType === 'background_image' && (
          <BackgroundTypeImage {...{ backgroundImageOptions, setAttributes }} />
        )}

        {backgroundType === 'background_color' && (
          <BackgroundTypeColor {...{ backgroundColorOptions, setAttributes }} />
        )}

        {backgroundType === 'background_gradient' && (
          <BackgroundTypeGradient
            {...{ backgroundGradientOptions, setAttributes }}
          />
        )}

        {backgroundType === 'background_image_color' && (
          <BackgroundTypeImageAndColor
            {...{ backgroundImageAndColorOptions, setAttributes }}
          />
        )}

        {backgroundType === 'picture_tag' && (
          <ImageAsBackground {...{ imageAsBackgroundOptions, setAttributes }} />
        )}

        {backgroundType === 'image_gradient' && (
          <ImageGradient
            {...{ imageGradientBackgroundOptions, setAttributes }}
          />
        )}

        {backgroundType === 'background_video' && (
          <BackgroundVideo {...{ backgroundVideoOptions, setAttributes }} />
        )}
        <ToggleControl
          label={__('Print Background Styles', 'b3rg')}
          checked={printBackgroundStyles}
          help={__(
            'Enable this option to include background styles when printing content.',
            'b3rg',
          )}
          onChange={(newValue) => {
            setAttributes({ printBackgroundStyles: newValue });
          }}
        />
      </PanelBody>
    </>
  );
};

export default BackgroundTypes;
